import { Container } from './styles'
import linkedin from '../../assets/linkedin.svg'
import githubIcon from '../../assets/github.svg'
import whatsapp from '../../assets/whatsapp.svg'

function scrollTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

export function Footer() {
  return (
    <Container className="footer">
      <a href="#home" className="logo" aria-label="Kedar Soni — Home">
        <span className="logo-text">Kedar<span className="logo-dot">.</span></span>
      </a>
      <div className="center-text">
        <button className="back-to-top" onClick={scrollTop} aria-label="Back to top">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M18 15l-6-6-6 6"/>
          </svg>
          Back to Top
        </button>
        <p>
          © 2026 Kedar Soni. All rights reserved.
        </p>
      </div>
      <div className="social-media">
        <a
          href="https://www.linkedin.com/in/kedarsoni/"
          target="_blank"
          rel="noreferrer"
          aria-label="Visit Kedar Soni on LinkedIn"
        >
          <img src={linkedin} alt="Linkedin" loading="lazy" width="30" height="30" />
        </a>
        <a
          href="https://github.com/kedarsoni04"
          target="_blank"
          rel="noreferrer"
          aria-label="Visit Kedar Soni on GitHub"
        >
          <img src={githubIcon} alt="GitHub" loading="lazy" width="30" height="30" />
        </a>
        <a
          href="https://api.whatsapp.com/send?phone=919558392775&text=Hello%20Kedar%20%2C%20I%20found%20your%20contact%20through%20your%20portfolio%20website"
          target="_blank"
          rel="noreferrer"
          aria-label="Contact Kedar Soni on WhatsApp"
        >
          <img src={whatsapp} alt="Whatsapp" loading="lazy" width="30" height="30" />
        </a>
      </div>
    </Container>
  )
}
